import { ICheckoutDetail } from '../../../../types/reducers/checkoutInfo';
import { formatPrice } from '../../../../utils/publishTerms';

import { IDetailRowProps } from '../../types';

export const getDetails = (checkoutDetails: ICheckoutDetail[]): IDetailRowProps[] =>
  checkoutDetails.reduce((details: IDetailRowProps[], detail) => {
    const { name, priceDescription, priceNote, discount, discountDescription } = detail;

    details.push({
      price: priceDescription,
      isDiscount: false,
      description: priceNote,
      label: name,
    });

    const discountValue = discount > 0 ? formatPrice({ price: -discount }) : null;

    if (discountValue) {
      details.push({ price: discountValue, label: discountDescription || 'Скидка', isDiscount: true });
    }

    return details;
  }, []);
